var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitnessBootcamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 622,
    height: 101,
    viewBox: "0 0 622 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4031_1155)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 622,
    height: 101,
    rx: 20,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 8.97852C603.19 8.97852 611.294 17.1315 611.294 26.9971V55.333L626.589 40.1924L631.457 35.374C638.609 28.2946 650.241 28.2945 657.393 35.374C664.494 42.4035 664.494 53.7625 657.393 60.792L652.523 65.6113L637.007 80.9717H665.728C675.917 80.9718 684.021 89.1247 684.021 98.9902C684.021 108.856 675.917 117.009 665.728 117.009H637.01L652.526 132.368L657.394 137.187C664.495 144.216 664.495 155.575 657.394 162.604C650.242 169.684 638.609 169.684 631.457 162.604L626.589 157.786L611.294 142.645V170.982C611.294 180.848 603.19 189.001 593 189.001C582.81 189.001 574.706 180.848 574.706 170.982V142.644L559.411 157.784L554.541 162.604C547.389 169.684 535.756 169.684 528.604 162.604C521.503 155.575 521.503 144.216 528.604 137.187L533.473 132.368L548.989 117.009H520.272C510.083 117.009 501.979 108.856 501.979 98.9902C501.979 89.1247 510.083 80.9718 520.272 80.9717H548.991L533.475 65.6113L528.605 60.791C521.504 53.7616 521.504 42.4025 528.605 35.373C535.757 28.294 547.389 28.2941 554.541 35.373L559.411 40.1934L574.706 55.334V26.9971C574.706 17.1315 582.81 8.97852 593 8.97852Z",
    stroke: "#512D9A",
    strokeWidth: 17.9574
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4031_1155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 622,
    height: 101,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessBootcamp);
export default __webpack_public_path__ + "static/media/fitness-bootcamp.ce9682210822c0cace61fa658b8dddfe.svg";
export { ForwardRef as ReactComponent };